import { ArrowLeft, Mail, MessageCircle, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "../logo.svg";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
      <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/95 backdrop-blur dark:border-slate-800 dark:bg-slate-950/95">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4 sm:px-5">
          <Link to="/" className="flex items-center gap-3">
            <img src={logo} alt="Logo Cynaxia" className="h-9 w-9" />
            <span className="text-lg font-bold tracking-wide text-amber-500 dark:text-amber-400">Cynaxia</span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-xl border border-slate-300 px-3 py-2 text-sm text-slate-700 transition hover:border-amber-500 hover:text-amber-700 dark:border-slate-700 dark:text-slate-100 dark:hover:border-amber-400 dark:hover:text-amber-300"
          >
            <ArrowLeft className="h-4 w-4" />
            Volver
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-4 py-10 sm:px-6 sm:py-16">
        <section className="space-y-6 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-700 dark:bg-slate-900">
          <div className="mb-2 flex items-center gap-3">
            <ShieldCheck className="h-7 w-7 text-amber-500 dark:text-amber-300" />
            <h1 className="text-3xl font-bold sm:text-4xl">Política de Privacidad</h1>
          </div>

          <p className="text-slate-700 dark:text-slate-200">
          En Cynaxia respetamos y protegemos la privacidad de nuestros usuarios.
          Esta Política de Privacidad explica cómo recopilamos, utilizamos,
          almacenamos y protegemos la información que los usuarios proporcionan
          al utilizar nuestros servicios, aplicaciones y plataformas digitales.
          </p>

          <h2 className="mt-8 text-2xl font-semibold">1. Información que recopilamos</h2>

          <p className="text-slate-700 dark:text-slate-200">
          Podemos recopilar información limitada necesaria para el correcto
          funcionamiento de nuestros servicios. Esta información puede incluir
          datos de identificación básica del usuario, información técnica del
          dispositivo, datos de uso de la plataforma y cualquier información
          proporcionada voluntariamente por el usuario al registrarse o utilizar
          nuestras aplicaciones.
          </p>

          <h2 className="mt-8 text-2xl font-semibold">2. Uso de la información</h2>

          <p className="text-slate-700 dark:text-slate-200">
          La información recopilada se utiliza exclusivamente para mejorar
          nuestros servicios, mantener la seguridad de nuestras plataformas,
          optimizar la experiencia del usuario y garantizar el correcto
          funcionamiento de nuestras aplicaciones y sistemas.
          </p>

          <h2 className="mt-8 text-2xl font-semibold">3. Protección de la información</h2>

          <p className="text-slate-700 dark:text-slate-200">
          En Cynaxia implementamos medidas técnicas, administrativas y de
          seguridad adecuadas para proteger la información almacenada en
          nuestros servidores. Utilizamos tecnologías modernas de protección
          de datos, control de acceso y protocolos de seguridad destinados a
          evitar accesos no autorizados, alteraciones, divulgación o destrucción
          de la información.
          </p>

          <p className="text-slate-700 dark:text-slate-200">
          A pesar de nuestros esfuerzos por garantizar la seguridad de los datos,
          ningún sistema informático es completamente invulnerable. Por lo tanto,
          no podemos garantizar seguridad absoluta frente a ataques externos o
          eventos fuera de nuestro control razonable.
          </p>

          <h2 className="mt-8 text-2xl font-semibold">4. Compartición de información</h2>

          <p className="text-slate-700 dark:text-slate-200">
          Cynaxia no vende, alquila ni comparte información personal de los
          usuarios con terceros. La información recopilada es utilizada
          únicamente para el funcionamiento interno de nuestros servicios,
          salvo en los casos en que la ley requiera la divulgación de dicha
          información ante autoridades competentes.
          </p>

          <h2 className="mt-8 text-2xl font-semibold">5. Eliminación de cuentas y datos</h2>

          <p className="text-slate-700 dark:text-slate-200">
          Todas nuestras aplicaciones y servicios incluyen mecanismos que
          permiten al usuario eliminar su cuenta de forma directa desde la
          plataforma o, en su defecto, solicitar la eliminación de su cuenta
          y datos asociados mediante contacto con nuestro equipo de soporte.
          </p>

          <p className="text-slate-700 dark:text-slate-200">
          Una vez recibida la solicitud de eliminación, Cynaxia procederá a
          eliminar o anonimizar la información asociada al usuario dentro de
          un plazo razonable, salvo cuando la conservación de ciertos datos
          sea necesaria para cumplir obligaciones legales o de seguridad.
          </p>

          <h2 className="mt-8 text-2xl font-semibold">6. Uso responsable de los servicios</h2>

          <p className="text-slate-700 dark:text-slate-200">
          Los usuarios son responsables del uso que hagan de nuestras
          aplicaciones, plataformas y herramientas. Cynaxia no se hace
          responsable por el uso indebido, ilegal, fraudulento o no autorizado
          de cualquiera de nuestros servicios por parte de los usuarios.
          </p>

          <h2 className="mt-8 text-2xl font-semibold">7. Descargo de responsabilidad</h2>

          <p className="text-slate-700 dark:text-slate-200">
          Cynaxia desarrolla herramientas tecnológicas destinadas a facilitar
          procesos digitales, educativos o productivos. El uso de dichas
          herramientas es responsabilidad exclusiva del usuario. La empresa
          no será responsable por daños directos, indirectos, incidentales o
          consecuentes derivados del uso o mal uso de cualquiera de nuestros
          productos o servicios.
          </p>

          <p className="text-slate-700 dark:text-slate-200">
          Asimismo, Cynaxia no garantiza que los servicios estén libres de
          interrupciones, errores técnicos o fallos temporales derivados de
          mantenimiento, actualizaciones o factores externos a nuestra
          infraestructura tecnológica.
          </p>

          <h2 className="mt-8 text-2xl font-semibold">8. Cambios en esta política</h2>

          <p className="text-slate-700 dark:text-slate-200">
          Cynaxia se reserva el derecho de modificar o actualizar esta Política
          de Privacidad en cualquier momento para adaptarla a cambios legales,
          tecnológicos o de funcionamiento de nuestros servicios.
          </p>

          <h2 className="mt-8 text-2xl font-semibold">9. Contacto</h2>

          <p className="text-slate-700 dark:text-slate-200">
          Si tienes preguntas sobre esta Política de Privacidad o deseas
          solicitar la eliminación de tu cuenta o datos personales, puedes
          contactarnos en el siguiente correo electrónico:
          </p>

          <p className="mt-2 flex items-center gap-2 font-medium text-amber-600 dark:text-amber-300">
            <Mail className="h-5 w-5" />
            <a href="mailto:cynaxia.recargame@cynaxia.cl" className="hover:underline">
              contacto@cynaxia.cl
            </a>
          </p>
          <a
            href="https://wa.me/56928232048?text=Hola%20Cynaxia%20tengo%20una%20consulta"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 flex items-center gap-2 text-emerald-600 transition hover:text-emerald-500 dark:text-emerald-400 dark:hover:text-emerald-300"
          >
            <MessageCircle className="h-5 w-5" />
            Contactar por WhatsApp
          </a>

          <h2 className="mt-8 text-2xl font-semibold">10. Aceptación de la política</h2>

          <p className="text-slate-700 dark:text-slate-200">
          Al utilizar cualquiera de los servicios, aplicaciones o plataformas
          desarrolladas por Cynaxia, el usuario declara haber leído,
          comprendido y aceptado íntegramente esta Política de Privacidad.
          </p>
        </section>
      </main>
    </div>
  );
};

export default PrivacyPolicy;